<template>
    <table>
        <thead>
        <tr>
            <th colspan="5">{{ this.title }}</th>
        </tr>
        </thead>
        <tbody>
        <tr>
            <th scope="col">Parameter</th>
            <th scope="col" v-show="symbols">Symbol</th>
            <th scope="col">Left</th>
            <th scope="col">Right</th>
            <th scope="col">Units</th>
        </tr>
        <tr v-for="(item, i) in table" :key="i">
            <td>{{ item.parameter }}</td>
            <td v-show="symbols">{{ item.symbol }}</td>
            <td>{{ item.valueL }}</td>
            <td>{{ item.valueR }}</td>
            <td>{{ item.units }}</td>
        </tr>
        <tr v-if="table.length === 0">
            <td colspan="5" style="text-align: center">
                No {{ title }} specified
            </td>
        </tr>
        </tbody>
    </table>
</template>

<script>
  export default {
    name: "DrawingTableLR",
    props: {
      title: String,
      table: Array,
      symbols: Boolean,
    },
  }
</script>

<style scoped src="./assets/drawing-table.scss" lang="scss"/>
<style scoped lang="scss">
    /*RIGHT VALUE COL*/
    td:nth-child(4) {
        text-align: right;
    }
</style>
